// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.id-card {
  width: 55mm;
  height: 85mm;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin-left: 35px;
}

.id-card:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.id-card__logo {
  margin-top: 9.2mm;
  padding: 0 7.2mm;
}

.id-card__logo img {
  width: 100%;
}

.id-card__main {
  width: 100%;
  height: auto;
}

.id-card__content {
  width: 100%;
  padding: 0 7.2mm;
  margin-bottom: 2.4mm;
}

.id-card__content__name {
  width: 100%;
  overflow: hidden;
  margin-bottom: 2mm;
}

.id-card__content__name p {
  font-family: "Bitter";
  font-size: 11pt;
  font-weight: bold;
}

.id-card__content__details {
  width: 100%;
}

.id-card__content__details p {
  font-family: "Inter";
  font-size: 8pt;
  font-weight: 360;
}

.id-card__content__details p.employee {
  font-weight: 630;
}

.id-card__content__details p.last {
  margin-bottom: 0;
}

.id-card__bottom {
  width: 100%;
  max-width: 55mm;
  height: 42.4mm;
  position: relative;
  margin: 0;
}

.id-card__bottom__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 101%;
  height: 101%;
  overflow: hidden;
  z-index: 10;
}

.id-card__bottom__bg svg {
  width: auto;
  height: auto;
}

.id-card__bottom__image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 37.6mm;
  height: 36.4mm;
  z-index: 20;
  display: flex;
  justify-content: center;
}

.id-card__bottom__image img {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/idCardFront/IdCardFront.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,wEAAwE;EACxE,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".id-card {\n  width: 55mm;\n  height: 85mm;\n  overflow: hidden;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: space-between;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  margin-left: 35px;\n}\n\n.id-card:hover {\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n}\n\n.id-card__logo {\n  margin-top: 9.2mm;\n  padding: 0 7.2mm;\n}\n\n.id-card__logo img {\n  width: 100%;\n}\n\n.id-card__main {\n  width: 100%;\n  height: auto;\n}\n\n.id-card__content {\n  width: 100%;\n  padding: 0 7.2mm;\n  margin-bottom: 2.4mm;\n}\n\n.id-card__content__name {\n  width: 100%;\n  overflow: hidden;\n  margin-bottom: 2mm;\n}\n\n.id-card__content__name p {\n  font-family: \"Bitter\";\n  font-size: 11pt;\n  font-weight: bold;\n}\n\n.id-card__content__details {\n  width: 100%;\n}\n\n.id-card__content__details p {\n  font-family: \"Inter\";\n  font-size: 8pt;\n  font-weight: 360;\n}\n\n.id-card__content__details p.employee {\n  font-weight: 630;\n}\n\n.id-card__content__details p.last {\n  margin-bottom: 0;\n}\n\n.id-card__bottom {\n  width: 100%;\n  max-width: 55mm;\n  height: 42.4mm;\n  position: relative;\n  margin: 0;\n}\n\n.id-card__bottom__bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 101%;\n  height: 101%;\n  overflow: hidden;\n  z-index: 10;\n}\n\n.id-card__bottom__bg svg {\n  width: auto;\n  height: auto;\n}\n\n.id-card__bottom__image {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 37.6mm;\n  height: 36.4mm;\n  z-index: 20;\n  display: flex;\n  justify-content: center;\n}\n\n.id-card__bottom__image img {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
